
import request from '@/service/request'

export const getServProjectPage = (params: COMMON.API.QueryParams) => {
  return request<SERVICE.ResponsePage<SERV.Detail[]>>({
    url: '/admin/servProject/page',
    method: 'GET',
    params
  })
}

export const addServProject = (data: SERV.Detail) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/servProject',
    method: 'POST',
    data
  })
}

export const getServProjectById = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/servProject/' + id,
    method: 'GET'
  })
}

export const updateServProject = (data: SERV.Detail) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/servProject',
    method: 'PUT',
    data
  })
}

export const delServProject = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/servProject/' + id,
    method: 'DELETE'
  })
}

export const offset = (data: {orderId: string, code: string, remark: string}) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/offset',
    method: 'POST',
    data
  })
}

export const getOffset = (code: string) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/offset',
    method: 'GET',
    params: {
      code: code
    }
  })
}

export const offsetList = (params: COMMON.API.QueryParams & {orderLabel: string, giftsLabel: string, userLabel: string}) => {
  return request<SERVICE.ResponsePage<SERV.Detail>>({
    url: '/admin/offset/page',
    method: 'GET',
    params
  })
}

export const bindServProject = (data: any) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/productServProject',
    method: 'POST',
    data
  })
}

export const delbindServProject = (id: number) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/productServProject/' + id,
    method: 'DELETE'
  })
}

export const getServProjectByProductId = (productId: number) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/productServProject/${productId}`,
    method: 'GET'
  })
}

export const getProjectByServId = (servId: string) => {
  return request<SERVICE.Response<SERV.Detail[]>>({
    url: `/admin/productServProject/product/${servId}`,
    method: 'GET'
  })
}

// /admin/servProject/onProduct/{productId}?page=1&pageSize=10
// 会返回对应的产品是否已经绑定上了
export const getServProjectBoolByProductId = (params: COMMON.API.QueryParams & {productId: string}) => {
  return request<SERVICE.ResponsePage<SERV.Detail[]>>({
    url: `/admin/servProject/onProduct/${params.productId}`,
    method: 'GET',
    params
  })
}
